import React, { useEffect, useMemo, useRef, useState } from 'react';
import { MapContainer, TileLayer, Marker, Tooltip, Polyline, ZoomControl, useMap } from 'react-leaflet';
import L from 'leaflet';

const HOME = { lat: 20.071228, lng: -98.708806 };

const CATS = {
  edu:        { label: 'Educación',  icon: 'school',          color: '#1d6fa5' },
  salud:      { label: 'Salud',      icon: 'local_hospital',  color: '#c0392b' },
  compras:    { label: 'Compras',    icon: 'shopping_cart',   color: '#f6802c' },
  transporte: { label: 'Transporte', icon: 'directions_car',  color: '#2e9d4f' },
  turismo:    { label: 'Turismo',    icon: 'photo_camera',    color: '#8e44ad' },
};
const CAT_ORDER = ['edu', 'salud', 'compras', 'transporte', 'turismo'];

const POIS = [
  // SALUD
  { id: 's1',  name: 'Nuevo Hospital General de Pachuca',           cat: 'salud',      lat: 20.1139034, lng: -98.7227859, time: '10 min', distance: '5.2 km' },
  { id: 's2',  name: 'Clínica ISSSTE Pachuca',                      cat: 'salud',      lat: 20.0640402, lng: -98.776833,  time: '12 min', distance: '7.1 km' },
  { id: 's3',  name: 'Hospital General · Consulta Externa',         cat: 'salud',      lat: 20.1170696, lng: -98.8331416, time: '20 min', distance: '13.8 km' },
  { id: 's4',  name: 'IMSS Pachuca',                                cat: 'salud',      lat: 20.115,     lng: -98.7236111, time: '11 min', distance: '5.5 km' },
  { id: 's5',  name: 'Hospital Español Pachuca',                    cat: 'salud',      lat: 20.1103805, lng: -98.772925,  time: '12 min', distance: '8 km' },
  { id: 's6',  name: 'Hospital Intermédica',                        cat: 'salud',      lat: 20.1100288, lng: -98.7740268, time: '12 min', distance: '8 km' },
  { id: 's7',  name: 'Hospital Español de Beneficencia',            cat: 'salud',      lat: 20.1187167, lng: -98.7433211, time: '10 min', distance: '6.5 km' },

  // EDUCACIÓN
  { id: 'e1',  name: 'UAEH · Ciudad del Conocimiento',              cat: 'edu', lat: 20.0950462, lng: -98.7143334, time: '5 min',  distance: '2.8 km' },
  { id: 'e2',  name: 'Universidad La Salle · Campus La Concepción', cat: 'edu', lat: 20.133975,  lng: -98.805239,  time: '14 min', distance: '11.5 km' },
  { id: 'e3',  name: 'CITNOVA · Pachuca',                           cat: 'edu', lat: 20.1342784, lng: -98.8015682, time: '14 min', distance: '11.2 km' },
  { id: 'e4',  name: 'CECyT 16 · IPN Pachuca',                      cat: 'edu', lat: 20.1125052, lng: -98.844943,  time: '17 min', distance: '14.5 km' },
  { id: 'e5',  name: 'Universidad del Fútbol · CAR Pachuca',        cat: 'edu', lat: 20.1376261, lng: -98.8102188, time: '15 min', distance: '12 km' },
  { id: 'e6',  name: 'Centro Cultural Europeo',                     cat: 'edu', lat: 20.1392486, lng: -98.8095778, time: '15 min', distance: '12 km' },
  { id: 'e7',  name: 'Instituto Tecnológico de Pachuca (ITP)',      cat: 'edu', lat: 20.0831322, lng: -98.773672,  time: '12 min', distance: '6.5 km' },
  { id: 'e8',  name: 'Universidad Digital del Estado de Hidalgo',   cat: 'edu', lat: 20.1151083, lng: -98.8333224, time: '20 min', distance: '13.5 km' },
  { id: 'e9',  name: 'Tecnológico de Monterrey · Campus Hidalgo',   cat: 'edu', lat: 20.0963796, lng: -98.7672098, time: '12 min', distance: '6.8 km' },

  // COMPRAS
  { id: 'c1',  name: 'Plaza Q · Pachuca',                                          cat: 'compras', lat: 20.0808832, lng: -98.7282439, time: '7 min',  distance: '3.6 km' },
  { id: 'c2',  name: 'Walmart Mineral de la Reforma · Blvd. Colosio',              cat: 'compras', lat: 20.088598,  lng: -98.7192885, time: '7 min',  distance: '3.5 km' },
  { id: 'c2b', name: 'Walmart Gran Patio Pachuca',                                 cat: 'compras', lat: 20.0923711, lng: -98.7598156, time: '12 min', distance: '6.2 km' },
  { id: 'c3',  name: 'Plaza Universidad · Pachuca',                                cat: 'compras', lat: 20.0972276, lng: -98.7166784, time: '6 min',  distance: '2.9 km' },
  { id: 'c4',  name: 'Explanada Pachuca',                                          cat: 'compras', lat: 20.036771,  lng: -98.7964498, time: '14 min', distance: '10 km' },

  // TRANSPORTE
  { id: 't1',  name: 'AIFA · Aeropuerto Felipe Ángeles',                cat: 'transporte', lat: 19.74110,   lng: -99.01360,   time: '55 min', distance: '78 km' },
  { id: 't2',  name: 'Central de Autobuses de Pachuca',                 cat: 'transporte', lat: 20.1066127, lng: -98.7520339, time: '12 min', distance: '6.8 km' },
  { id: 't3',  name: 'Aeropuerto Ing. Juan Guillermo Villasana',        cat: 'transporte', lat: 20.074479,  lng: -98.7827981, time: '14 min', distance: '8 km' },

  // TURISMO
  { id: 'tu1', name: 'Ex Convento de Epazoyucan',                             cat: 'turismo', lat: 20.0156907, lng: -98.636647,  time: '15 min', distance: '10 km' },
  { id: 'tu2', name: 'Acueducto del Padre Tembleque (UNESCO)',                cat: 'turismo', lat: 19.8344308, lng: -98.6626136, time: '35 min', distance: '28 km' },
  { id: 'tu3', name: 'Ex Convento de Zempoala',                               cat: 'turismo', lat: 19.9149228, lng: -98.6693781, time: '28 min', distance: '22 km' },
  { id: 'tu4', name: 'Zempoala · Pueblo',                                     cat: 'turismo', lat: 19.913647,  lng: -98.6683097, time: '28 min', distance: '22 km' },
  { id: 'tu5', name: 'Museo Interactivo El Rehilete',                         cat: 'turismo', lat: 20.0766482, lng: -98.7770421, time: '13 min', distance: '7.5 km' },
  { id: 'tu6', name: 'Parque Cultural Hidalguense',                           cat: 'turismo', lat: 20.0947761, lng: -98.7728274, time: '13 min', distance: '7.8 km' },
  { id: 'tu7', name: 'Mirador Cristo Rey · Camino',                           cat: 'turismo', lat: 20.131644,  lng: -98.7156887, time: '15 min', distance: '8.0 km' },
  { id: 'tu8', name: 'Museo del Fútbol · Salón de la Fama',                   cat: 'turismo', lat: 20.095194,  lng: -98.7733944, time: '13 min', distance: '7.8 km' },
  { id: 'tu9', name: 'Estadio Hidalgo · Tuzos del Pachuca',                   cat: 'turismo', lat: 20.1051453, lng: -98.7560536, time: '12 min', distance: '6.9 km' },
  { id: 'tu10', name: 'Tuzoofari',                                            cat: 'turismo', lat: 20.0226471, lng: -98.6475275, time: '20 min', distance: '12 km' },
  { id: 'tu11', name: 'Mineral del Chico · Pueblo Mágico',                    cat: 'turismo', lat: 20.2150472, lng: -98.7310435, time: '40 min', distance: '22 km' },
  { id: 'tu12', name: 'Real del Monte · Pueblo Mágico',                       cat: 'turismo', lat: 20.1381378, lng: -98.6734788, time: '25 min', distance: '13 km' },
  { id: 'tu13', name: 'Hacienda San Miguel Regla',                            cat: 'turismo', lat: 20.2190263, lng: -98.5600842, time: '50 min', distance: '23 km' },
  { id: 'tu14', name: 'Auditorio Gota de Plata',                              cat: 'turismo', lat: 20.0920833, lng: -98.7745366, time: '13 min', distance: '7.5 km' },
  { id: 'tu15', name: 'Cerro Las Navajas',                                    cat: 'turismo', lat: 20.0855556, lng: -98.5519444, time: '30 min', distance: '17 km' },
  { id: 'tu16', name: 'Tulancingo, Hgo.',                                     cat: 'turismo', lat: 20.0904802, lng: -98.3690922, time: '40 min', distance: '36 km' },
  { id: 'tu17', name: 'Reloj Monumental de Pachuca',                          cat: 'turismo', lat: 20.127567,  lng: -98.7318168, time: '12 min', distance: '6.8 km' },
];

const FILTERS = [
  { id: 'all', label: 'Todos', icon: 'apps' },
  ...CAT_ORDER.map((c) => ({ id: c, label: CATS[c].label, icon: CATS[c].icon })),
];

const HOME_ICON = L.divIcon({
  className: 'locmap-marker-home',
  html: `
    <div class="locmap-marker-home-pulse"></div>
    <div class="locmap-marker-home-pin">
      <span class="icon-font">home</span>
    </div>
  `,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});

const POI_ICONS = Object.fromEntries(
  Object.entries(CATS).map(([id, c]) => [
    id,
    L.divIcon({
      className: 'locmap-marker-poi',
      html: `<div class="locmap-marker-poi-inner" style="background:${c.color}"><span class="icon-font">${c.icon}</span></div>`,
      iconSize: [32, 32],
      iconAnchor: [16, 16],
    }),
  ])
);

function FitToVisible({ visible, trigger }) {
  const map = useMap();
  useEffect(() => {
    if (!map) return;
    const points = [[HOME.lat, HOME.lng], ...visible.map((p) => [p.lat, p.lng])];
    if (points.length === 1) { map.setView(points[0], 14); return; }
    const bounds = L.latLngBounds(points);
    map.fitBounds(bounds, { padding: [50, 50], maxZoom: 14, animate: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, map]);
  return null;
}

function FlyToPoi({ target }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !target) return;
    map.flyTo([target.lat, target.lng], 15, { duration: 0.9 });
  }, [target, map]);
  return null;
}

export default function LocationMapPro() {
  const [activeCat, setActiveCat] = useState('all');
  const [hoverId, setHoverId] = useState(null);
  const [flyTarget, setFlyTarget] = useState(null);
  const polylineRefs = useRef({});

  const visible = useMemo(
    () => POIS.filter((p) => activeCat === 'all' || p.cat === activeCat),
    [activeCat]
  );

  // Conteos por categoría
  const counts = useMemo(() => {
    const out = { all: POIS.length };
    POIS.forEach((p) => { out[p.cat] = (out[p.cat] || 0) + 1; });
    return out;
  }, []);

  // Grupos para listar por categoría
  const groups = useMemo(() => {
    return CAT_ORDER
      .map((c) => ({ cat: c, items: visible.filter((p) => p.cat === c) }))
      .filter((g) => g.items.length > 0);
  }, [visible]);

  const directionsHref = `https://www.google.com/maps/dir/?api=1&destination=${HOME.lat},${HOME.lng}`;

  // Resalta polyline vía ref sin re-render del mapa
  useEffect(() => {
    Object.entries(polylineRefs.current).forEach(([id, poly]) => {
      if (!poly) return;
      const isHover = id === hoverId;
      poly.setStyle({
        weight: isHover ? 3.5 : 1.5,
        opacity: isHover ? 0.95 : 0.40,
        dashArray: isHover ? null : '6 6',
      });
    });
  }, [hoverId]);

  const handleCardClick = (p) => {
    // Force new reference each click so useEffect refires si es el mismo POI
    setFlyTarget({ ...p, _t: Date.now() });
  };

  const handleFilterChange = (id) => {
    setActiveCat(id);
    setFlyTarget(null);
  };

  return (
    <section id="ubicacion" className="locmap-section locmap-v3" data-testid="locmap-section">
      <div className="page-padding">
        <div className="container-large">
          <div className="locmap-head">
            <div className="text-label" style={{ color: 'rgba(247,252,255,0.6)' }}>ubicación estratégica</div>
            <h2 className="sm-h2" data-reveal>
              Todo lo que necesitas, <span className="serif-accent">muy cerca.</span>
            </h2>
            <p className="text-size-medium" data-reveal style={{ maxWidth: '720px', color: 'rgba(255,255,255,0.85)' }}>
              Pachuquilla, Mineral de la Reforma. A 10 minutos del centro de Pachuca, conectado a la autopista México-Pachuca
              y rodeado de los Pueblos Mágicos más emblemáticos de Hidalgo.
            </p>
          </div>

          <div className="locmap-grid">
            {/* PANEL IZQUIERDO */}
            <aside className="locmap-controls">
              <div className="locmap-cats" data-testid="locmap-cats">
                {FILTERS.map((f) => (
                  <button
                    key={f.id}
                    className={`locmap-cat${activeCat === f.id ? ' active' : ''}`}
                    onClick={() => handleFilterChange(f.id)}
                    style={{ '--cat-color': CATS[f.id]?.color || 'var(--brand-accent)' }}
                    data-testid={`locmap-cat-${f.id}`}
                  >
                    <span className="icon-font">{f.icon}</span>
                    <span>{f.label}</span>
                    <span className="locmap-cat-count">{counts[f.id] || 0}</span>
                  </button>
                ))}
              </div>

              <div className="locmap-poi-scroll" data-testid="locmap-poi-list">
                {groups.map((g) => (
                  <div key={g.cat} className="locmap-poi-group">
                    <div className="locmap-poi-group-head" style={{ '--cat-color': CATS[g.cat].color }}>
                      <span className="locmap-poi-group-dot" style={{ background: CATS[g.cat].color }}>
                        <span className="icon-font">{CATS[g.cat].icon}</span>
                      </span>
                      <span className="locmap-poi-group-label">{CATS[g.cat].label}</span>
                      <span className="locmap-poi-group-count">{g.items.length}</span>
                    </div>
                    {g.items.map((p) => (
                      <button
                        key={p.id}
                        type="button"
                        className={`locmap-poi-item${hoverId === p.id ? ' hover' : ''}`}
                        onMouseEnter={() => setHoverId(p.id)}
                        onMouseLeave={() => setHoverId(null)}
                        onClick={() => handleCardClick(p)}
                        data-testid={`locmap-poi-${p.id}`}
                      >
                        <div className="locmap-poi-meta">
                          <div className="locmap-poi-name">{p.name}</div>
                          <div className="locmap-poi-stats">
                            <span><span className="icon-font">schedule</span>{p.time}</span>
                            <span><span className="icon-font">straighten</span>{p.distance}</span>
                          </div>
                        </div>
                        <span className="locmap-poi-go icon-font">arrow_forward</span>
                      </button>
                    ))}
                  </div>
                ))}
              </div>

              <a
                href={directionsHref}
                target="_blank"
                rel="noopener noreferrer"
                className="locmap-directions"
                data-testid="locmap-directions"
              >
                <span className="icon-font">directions</span>
                Cómo llegar en Google Maps
                <span className="icon-font">arrow_forward</span>
              </a>
            </aside>

            {/* MAPA */}
            <div className="locmap-canvas locmap-canvas-real" data-testid="locmap-canvas">
              <MapContainer
                center={[HOME.lat, HOME.lng]}
                zoom={13}
                scrollWheelZoom={false}
                zoomControl={false}
                className="locmap-leaflet"
                style={{ height: '100%', width: '100%' }}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
                  url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                  subdomains="abcd"
                  maxZoom={19}
                />
                <ZoomControl position="bottomright" />
                <FitToVisible visible={visible} trigger={activeCat} />
                <FlyToPoi target={flyTarget} />

                <Marker position={[HOME.lat, HOME.lng]} icon={HOME_ICON}>
                  <Tooltip direction="top" offset={[0, -24]} opacity={0.95}>
                    <strong>Santa Mónica Residencial</strong><br />
                    Pachuquilla, Mineral de la Reforma
                  </Tooltip>
                </Marker>

                {visible.map((p) => (
                  <React.Fragment key={p.id}>
                    <Polyline
                      ref={(el) => { if (el) polylineRefs.current[p.id] = el; }}
                      positions={[[HOME.lat, HOME.lng], [p.lat, p.lng]]}
                      pathOptions={{
                        color: CATS[p.cat]?.color || '#064060',
                        weight: 1.5,
                        opacity: 0.40,
                        dashArray: '6 6',
                      }}
                    />
                    <Marker
                      position={[p.lat, p.lng]}
                      icon={POI_ICONS[p.cat]}
                      eventHandlers={{
                        mouseover: () => setHoverId(p.id),
                        mouseout:  () => setHoverId(null),
                      }}
                    >
                      <Tooltip direction="top" offset={[0, -16]} opacity={0.95}>
                        <strong>{p.name}</strong><br />
                        {p.time} · {p.distance}
                      </Tooltip>
                    </Marker>
                  </React.Fragment>
                ))}
              </MapContainer>

              <div className="locmap-overlay-legend">
                {Object.entries(CATS).map(([id, c]) => (
                  <span key={id}><i style={{ background: c.color }} /> {c.label}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
